import axios from "axios";
import store from "../redux/store/store"
import { logoutAction } from "../redux/slices/users/usersSlice";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch(logoutAction());
      localStorage.removeItem("userInfo");
      localStorage.removeItem("cartItems");

      // Evita loop infinito si el 401 ocurre en la propia página de login
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axios;